export const MISSING_AGENT_CREDENTIAL_MESSAGE =
  "No AI agent credential is available. Connect Anthropic or GitHub Copilot on the project's Connectors page, set a Claude OAuth token in your user settings, or configure a key in the project settings or the tenant settings."
